<template>
  <div class="home">
    <v-col md="8" offset-md="2">
      <v-card>
        <v-card-title class="secondary white--text">
          <v-icon color="white">mdi-alert</v-icon> Changement de mot de passe
        </v-card-title>

        <v-card-text class="body-1">
          <p class="pt-4">
            Vous allez changer votre mot de passe.
          </p>
          <p>
            Veuillez saisir votre ancien mot de passe, ainsi que le nouveau.
          </p>
        </v-card-text>

        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-alert type="error" v-if="errorserver">
                <p>{{ errorserver }}.</p>
                <p>
                  Le mot de passe n'a pas été mis à jour.
                </p>
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text>
          <v-form v-model="valid" lazy-validation ref="form">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  label="Ancien mot de passe"
                  placeholder="Veuillez saisir votre ancien mot de passe"
                  v-model.trim="ancien"
                  dense
                  :disabled="loading"
                  filled
                  :rules="[obligatoireRule()]"
                  :type="afficheancien ? 'text' : 'password'"
                  :append-icon="afficheancien ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="afficheancien = !afficheancien"
                />
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Mot de passe"
                  placeholder="Veuillez saisir votre mot de passe"
                  v-model.trim="motdepasse"
                  dense
                  :disabled="loading"
                  filled
                  :rules="motdepasseRules"
                  :error-count="4"
                  :type="affichemotdepasse ? 'text' : 'password'"
                  :append-icon="affichemotdepasse ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="affichemotdepasse = !affichemotdepasse"
                />
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Confirmer mot de passe"
                  placeholder="Veuillez confirmer votre mot de passe"
                  v-model.trim="confirmation"
                  dense
                  :disabled="loading"
                  filled
                  :rules="[
                    () =>
                      motdepasseIdentiques() ||
                      'Les mots de passes doivent être identiques',
                  ]"
                  :type="afficheconfirmation ? 'text' : 'password'"
                  :append-icon="afficheconfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="afficheconfirmation = !afficheconfirmation"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" text @click="envoyer" :loading="envoi">
            Envoyer
          </v-btn>
          <v-btn text @click="annuler">
            Annuler
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import toasted from '@/utils/toasted';
import ValidationRules from '@/plugins/mixins/ValidationRules';
export default {
  mixins: [ValidationRules],
  data() {
    const majuscule = m => /[A-Z]/.test(m) || 'doit contenir une majuscule';
    const minuscule = m => /[a-z]/.test(m) || 'doit contenir une minuscule';
    const special = m => /\W/.test(m) || 'doit contenir un caractère spécial';
    const taille = m =>
      (m || '').length >= 8 || 'doit avoir au moins 8 caractères';

    return {
      envoi: false,
      ancien: null,
      motdepasse: null,
      confirmation: null,
      afficheancien: false,
      affichemotdepasse: false,
      afficheconfirmation: false,
      errorserver: null,
      loading: false,
      valid: false,
      motdepasseRules: [
        majuscule,
        minuscule,
        special,
        taille,
        this.obligatoireRule(),
      ],
    };
  },
  methods: {
    envoyer() {
      this.errorserver = null;
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.envoi = true;
        this.$api('/motdepasse/change', '/oauth')
          .post({ ancien: this.ancien, motDePasse: this.motdepasse })
          .then(() => {
            toasted.info('auth.motDePasseChange');
            this.$auth.login(this.$auth.userid(), this.motdepasse, false);
          })
          .catch(error => {
            this.errorserver = error.error;
          })
          .finally(() => {
            this.envoi = false;
            this.loading = false;
          });
      }
    },
    annuler() {
      this.$router.push({ name: 'home' });
    },
    motdepasseIdentiques() {
      return this.motdepasse === this.confirmation;
    },
  },
};
</script>

<style scoped>
.home {
  background-image: url('~@/assets/images/amanda-vick-eRAq9asBIy4-unsplash.jpg');
  background-size: cover;
  height: 100%;
}

.large {
  width: 100%;
}
</style>
